var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'underscore.string', 'backbone', 'core', 'app-common/lib/jquery.velocity'], function($, _, _s, Backbone, core) {
  var BaseView;
  return BaseView = (function(_super) {

    __extends(BaseView, _super);

    function BaseView() {
      BaseView.__super__.constructor.apply(this, arguments);
    }

    BaseView.prototype.pageId = null;

    BaseView.prototype.className = 'page-wrapper';

    BaseView.prototype.sidebarDuration = 200;

    BaseView.prototype.initialize = function(options, params) {
      var _this = this;
      return $(document).on('click', '#sidebar.minimized', function() {
        return _this.maximizeSidebar();
      });
    };

    BaseView.prototype.render = function(content) {
      var pageId;
      if (content == null) {
        content = '';
      }
      pageId = _s.underscored(this.pageId + '_widget');
      this.$el.append(content);
      $('.backbone-container').attr('id', pageId).html(this.$el);
      return this;
    };

    BaseView.prototype.selector = function() {
      return '#' + $('.backbone-container').attr('id');
    };

    BaseView.prototype.remove = function() {
      return $(document).off('click', '#sidebar.minimized');
    };

    BaseView.prototype.minimizeSidebar = function() {
      var _this = this;
      if (!$('#sidebar').data('minimized')) {
        $('#sidebar').data('minimized', true);
        this.trigger('sidebar:minimized');
        $('.sidebar-inner').hide();
        $('#main-container').velocity('stop').velocity({
          'margin-left': '49px'
        }, {
          duration: this.sidebarDuration
        });
        return $('#sidebar').velocity('stop').velocity({
          opacity: 1,
          width: '50px'
        }, {
          duration: this.sidebarDuration,
          complete: function() {
            $('.fullscreen-exit').velocity('stop').velocity('fadeIn', _this.sidebarDuration / 2);
            return $('#sidebar').addClass('minimized');
          }
        });
      }
    };

    BaseView.prototype.maximizeSidebar = function() {
      if ($('#sidebar').data('minimized')) {
        $('#sidebar').data('minimized', false);
        $('#sidebar').removeClass('minimized');
        this.trigger('sidebar:maximized');
        $('.fullscreen-exit').velocity('stop').velocity('fadeOut', {
          duration: this.sidebarDuration / 2
        });
        $('#main-container').velocity('stop').velocity({
          'margin-left': '219px'
        }, {
          duration: this.sidebarDuration
        });
        return $('#sidebar').velocity('stop').velocity({
          opacity: 1,
          width: '220px'
        }, {
          duration: this.sidebarDuration,
          complete: function() {
            return $('.sidebar-inner').hide().velocity('fadeIn', this.sidebarDuration / 2);
          }
        });
      }
    };

    return BaseView;

  })(Backbone.View);
});
